module.exports = {
	title: '湖北楚建通-增值服务平台',
	/**
	 * 不同环境访问项目名
	 */
	publicPath: process.env.NODE_ENV === 'production' ? '/cjt-service/' : '/cjt-service/',
	outputDir: process.env.NODE_ENV === 'production' ? 'cjt-service' : 'cjt-service'
}
